import { convertFromRaw, EditorState, DraftDecoratorType } from 'draft-js'
import { HeadingTypeEnum } from 'common/enums/HeadingTypeEnum'

export function createStateFromRaw(
  rawContentState: string,
  decorator?: DraftDecoratorType,
): EditorState {
  try {
    return EditorState.createWithContent(
      convertFromRaw(JSON.parse(rawContentState)),
      decorator,
    )
    // biome-ignore lint/correctness/noUnusedVariables: <explanation>
  } catch (e) {
    return EditorState.createEmpty()
  }
}

export const getTextFromHtml = (html: string) => {
  if (!html) return ''

  const textWithoutTags = html.replace(/<\/?[^>]+(>|$)/g, '').trim()
  const parser = new DOMParser()

  return (
    parser.parseFromString(
      `<!doctype html><body>${textWithoutTags}`,
      'text/html',
    ).body.textContent || ''
  )
}

export const getHeadingTypeFromHtml = (
  html: string,
): HeadingTypeEnum | null => {
  const tag = html.match(/<(h[1-6])\b/i)
  if (tag?.[1]) {
    switch (tag[1]) {
      case 'h1':
        return HeadingTypeEnum.HeaderOne
      case 'h2':
        return HeadingTypeEnum.HeaderTwo
      case 'h3':
        return HeadingTypeEnum.HeaderThree
      case 'h4':
        return HeadingTypeEnum.HeaderFour
      case 'h5':
        return HeadingTypeEnum.HeaderFive
      case 'h6':
        return HeadingTypeEnum.HeaderSix

      default:
        break
    }
  }
  return null
}
